import React, { FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { PostSummary } from "@app/models";
import { PostCard } from "@app/components";

type Props = {
  posts: PostSummary[];
};

export const RelatedPublications: FC<Props> = ({ posts }) => {
  const { t } = useTranslation("t_blog");

  return (
    <div>
      <h3 className={classNames("mb-4 px-3", "md:px-0")}>
        {t("related_publications")}
      </h3>
      <div className="flex flex-wrap gap-x-8 gap-y-25">
        {posts.map((p) => (
          <div key={p.title} className={classNames("md:flex-1")}>
            <PostCard {...p} />
          </div>
        ))}
      </div>
    </div>
  );
};
